<div class="content">
  <div class="treatment-card"  *ngFor="let treatment of treatments">
    <div class="treatment-avatar"  (click)="editTreatment(treatment)" [style.background-color]="getColorFromName(treatment.name)">{{treatment.name.substring(0,1)}}</div>
    <div class="treatment-text">
      <div class="treatment-name"  (click)="editTreatment(treatment)" >{{treatment.name}}</div>
      <div class="dosage"  (click)="editTreatment(treatment)" >{{treatment.description}}</div>
      <div class="activate-button" *ngIf="treatment.status === 'DISABLED'">
        <button  (click)="toggleActive(treatment)" mat-button >
          Activate
        </button>
      </div>
      <div class="activate-button" *ngIf="treatment.status === 'ACTIVE'">
      <button  (click)="toggleActive(treatment)" mat-button >
        Deactivate
      </button></div>
    </div>
  </div>
  <div class="add-new-container">
    <button mat-fab color="primary" (click)="editTreatment(null)">
   + Add new
    </button>
  </div>
</div>
